import {
  Box,
  Grid,
  Stack,
} from "@mui/material";

import AppBar from "@/components/AppBar"
import Typography from "@mui/material/Typography";
import { Swiper } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import LightStreamPlayer from "@/components/LightStreamPlayer/LightStreamPlayer.tsx";
import { CFStreamSignedItem } from "@/services/models.ts";
import SmallGenreButton from "@/components/common/SmallGenreButton.tsx";

export default function UserSignup() {
  const CFStreamSignedItems: CFStreamSignedItem[] = [
    {
      token: 'eyJhbGciOiJSUzI1NiIsImtpZCI6ImUwZjdhMmQwMDAwNzExOWM2OWI4NjI0NDM5OGVlNGQ1In0.eyJzdWIiOiJmODI1Y2RlYmMzYWFkYTEyYjliOTJmN2RiMGFiMjFhNiIsImtpZCI6ImUwZjdhMmQwMDAwNzExOWM2OWI4NjI0NDM5OGVlNGQ1IiwiZXhwIjoiMTczNDE3NDUyMCIsIm5iZiI6IjE3MzQwODQ1NDAifQ.qy-rGPv2D2fBEFGgTQ0JFhT_BEit-5cG2rtANuwo5yYp9pCCSuzkQRVreshE8931151LZ2aj0vDkcky6U06fsVwTAzKEhGbLQFn_SaHkSlantAeKds29ay0PafBDbb12Laq7wB6Grp_fBOch3GZrlv1fXXODdy32-iOroAW0W98uYamUPeSpgs9geYb6M28rxsaO4q3kNMZlsr96ZKBL_CDvaf1-cbAxZirwZNy-D36NZ2qTh--O_HJBriuPo0-XFvgDjFi3Aeh2zUXj0QZ302CuQr-GvG8pFppUHsyn2GxgugVUgp0Gf2lLPmwGFYqMjOHEk_sqa6ORpfsoqm9-lw',
      title: '美人すぎる人妻・寝取られ志願 『今から貴方以外の男に中出しされます。』 たかせ由奈',
      video_uid: 'b0bebf1c02b80d6afb342b30a1e0fdc3',
      thumbnail_start_sec: 2000,
      tags: ['新作', '準新作'],
    },
    {
      token: 'eyJhbGciOiJSUzI1NiIsImtpZCI6ImUwZjdhMmQwMDAwNzExOWM2OWI4NjI0NDM5OGVlNGQ1In0.eyJzdWIiOiJlOTg0YzcyZWQwMzA3ZDI1ZmJjMTRmNTFmNmVkMThmOCIsImtpZCI6ImUwZjdhMmQwMDAwNzExOWM2OWI4NjI0NDM5OGVlNGQ1IiwiZXhwIjoiMTczNDE3NDUyMCIsIm5iZiI6IjE3MzQwODQ1NDAifQ.Sah_jiz7RtgrQtLRpCLCwKqunkyp7ocl0G-EpAG5ve422KFbdKEgRgo1mEQvzjvLXbx4TSItT7Pf6OU0IXh1ScvfmnRsFabHxoheLLVguMymMh3HzmnWLeZiXeNnNqJqByhdVeCfoeOIVyElPzPglbJQJuiKR0JramZ7EUzI69BABnTW9nogDD5hfa1LtF24L11--IuKF-Tpo7yG_PDfFmU9kzGkqkMTeMQsOzShtewi3WeOWr76InfW4Idjj43pwWPlyUoDd05yjBK17cq1693Tj7h8NlUGBU04A2SdkMHvsVSOYIOkWXg1KbrtM5v-kwLtBH0_pu95J-rFVVj7Ig',
      title: 'トーキョー・ロシュツ 坂口みほの',
      video_uid: '12965fe22ed10a05a72c66bc68e1fe9d',
      thumbnail_start_sec: 1000,
      tags: ['新作', '準新作'],
    },
    {
      token: 'eyJhbGciOiJSUzI1NiIsImtpZCI6ImUwZjdhMmQwMDAwNzExOWM2OWI4NjI0NDM5OGVlNGQ1In0.eyJzdWIiOiJjMDdiZGNhZmFkNmI1MDRlZmE4NGM2YzUxYjE2MWU4ZiIsImtpZCI6ImUwZjdhMmQwMDAwNzExOWM2OWI4NjI0NDM5OGVlNGQ1IiwiZXhwIjoiMTczOTAzMjgyNSIsIm5iZiI6IjE3Mzg5NDI4NDUifQ.m_clWIlPkX47j4AZfh70IarmCNU4c4jmSmQ51oYgnZhAdNFhbvMfipBJWKjAp-WC32ekfDjIIZxhKIXjZ9XCrZoHXYGWyNpuGSNJCqcsHnU6w6-GOfqLZVK8sZbDXdwxjET7Uj5x1FC4Ib8JZQEyGtH1Azbl4tNu3-xea8679gCZ4S3VpvmFEfhb_gyhvafanHpeWAXlHM4tttKseLO9t0hc21wdLYDlhn4UnWcYEtU045K6NiVpSffjr98os1tICOof_3Lhn9A0QMWe02qlC_v2Zp-k19Pzo8NbuOtpOCRMz32FrxbEWXijJ2PFQWe-ZAcwoKiCZxu-f7XYw7_gYw',
      title: 'オ●●コおっぴろげ！お姉ちゃん 四六時中濡れまくり、前戯いらずの即挿入セックス 佐々木マリア',
      video_uid: 'c07bdcafad6b504efa84c6c51b161e8f',
      thumbnail_start_sec: 1000,
      tags: ['新作', '準新作'],
    },
    {
      token: 'eyJhbGciOiJSUzI1NiIsImtpZCI6ImUwZjdhMmQwMDAwNzExOWM2OWI4NjI0NDM5OGVlNGQ1In0.eyJzdWIiOiI2OTIxYjMzM2FmM2U0ZDg1YzQ2MTRmMDEyOWI3ZDJjYyIsImtpZCI6ImUwZjdhMmQwMDAwNzExOWM2OWI4NjI0NDM5OGVlNGQ1IiwiZXhwIjoiMTczOTAzMjgyNiIsIm5iZiI6IjE3Mzg5NDI4NDYifQ.Ofa4QAsIcbi3iM2ZzGXBI5YVP5jHIoWifoLaMfwXW18fDOmt0wq_C3-uXqPIbs9vzg9wjv4kHsuC1zEePoQpVVEV59ecMNbSvhhW6XWusRO9oto2d7sOTEhfSgPKwwuhFb9sbtF6rhgHkD0oleKmk1bVTQzGJv38Y5RFc_IbZyQ_feiUkdMOj4cYHA5pw9FfO4K-nHdWyvY2xtAAwWo6vcR-Tfj6WUt_gbj84Txgh1QB4VrjFWWEs6x2RVS1nCDXi1ZXICUB_VWP9moRiMBVK1BAkT0Ic70XBDPtk5fVljgHW7ScVIb3gtKDWcaDhDPpcrfFG0QrJMlgp9Qgm9VoQw',
      title: 'マッチングアプリで知り合った不倫関係の女子と久しぶりのホテル密会。',
      video_uid: '6921b333af3e4d85c4614f0129b7d2cc',
      thumbnail_start_sec: 1000,
      tags: ['新作', '準新作'],
    },
    {
      token: 'eyJhbGciOiJSUzI1NiIsImtpZCI6ImUwZjdhMmQwMDAwNzExOWM2OWI4NjI0NDM5OGVlNGQ1In0.eyJzdWIiOiI5NDA1OTJiMmExZmM5YWYwZDNmMWU2NjRiODI5NDZhMSIsImtpZCI6ImUwZjdhMmQwMDAwNzExOWM2OWI4NjI0NDM5OGVlNGQ1IiwiZXhwIjoiMTczOTAzMjgyNiIsIm5iZiI6IjE3Mzg5NDI4NDYifQ.Abdub2tr8fnvLhUAHao-emlZjv914JIJB2EhtQzxXHxflbuz8Uf0YfU0vxDT2w6sk0RmlxdeK6kEphVoGgQxVhye7JrbPvAe8WRe299D4uKnIIEkA0FFHoyNGtQitHuyhlOHlPSjvZDn0VzoxAD-FyiiP32VRFq2t7LQLOK6zIk3iyu4HpC5k7GS6ntJjfgkytrjmXtxYz5bI-y89zHwQo3FCgYgddVihzxu2-wjBAjullX7hSHq-fqKXJ5vAuKAVBGs9Ma-uOFWGI3-AEt7ypdLV3PswFzAVaqhQRAT9ywTUGBwVWvz9HrfDyidB9-bYPl0l5BFf2cWwyVKcCb7Rw',
      title: '初撮り中出しアルバイト 変態願望で犯●れにきた絶世美女 市川ありさ',
      video_uid: '940592b2a1fc9af0d3f1e664b82946a1',
      thumbnail_start_sec: 1000,
      tags: ['新作', '準新作'],
    },
    {
      token: 'eyJhbGciOiJSUzI1NiIsImtpZCI6ImUwZjdhMmQwMDAwNzExOWM2OWI4NjI0NDM5OGVlNGQ1In0.eyJzdWIiOiI5MGNjZmNjYTA0MjNiOTFjYjk2MjMxNjBjMWE2MGQ1ZSIsImtpZCI6ImUwZjdhMmQwMDAwNzExOWM2OWI4NjI0NDM5OGVlNGQ1IiwiZXhwIjoiMTczOTAzMjgyNiIsIm5iZiI6IjE3Mzg5NDI4NDYifQ.pI3U71tQeb1aJgccKqHIEahtvZlyo0_1U5MuDg4zE5sMdQDUA2Nnxl5_Su_3yV7AzgGy-V-_Sf31C9IqK6BTfa9EOd6uHsv8Lj25zM6pwbw7p7IbKe8ESEfC3EYasKiUdide5g7eQaJBHncsMVWyzE-TAv3SnCIeZr1XKx8nNm5TPY60RIXWGrYtxy9M4gYdYXtdZ-WjWSfQ0EWglj9g6ZYZ1IAR22XxFq7p1_eZHrwC4ORz1ESr5st-soP4OXwGws19oMWSL1dyUr1OB4Wh_m_IYUgFsBOirf7pIcXUy_b5A808Karog4Q3Vurc3R2twZfmK2mIIGYN1PhmrRhu3A',
      title: '渚みつきベスト',
      video_uid: '90ccfcca0423b91cb9623160c1a60d5e',
      thumbnail_start_sec: 1000,
      tags: ['新作', '準新作'],
    },
    {
      token: 'eyJhbGciOiJSUzI1NiIsImtpZCI6ImUwZjdhMmQwMDAwNzExOWM2OWI4NjI0NDM5OGVlNGQ1In0.eyJzdWIiOiJmYjJiYWEzNmRhODZlZTdiYjk4NzhmYzI4NjVkNjliZiIsImtpZCI6ImUwZjdhMmQwMDAwNzExOWM2OWI4NjI0NDM5OGVlNGQ1IiwiZXhwIjoiMTczOTAzMjgyNiIsIm5iZiI6IjE3Mzg5NDI4NDYifQ.wCEaeo0p-ZyakS2lpey3QHLZmJrv8mQkd5lobznISwmSjAY54gpawRhKT9uIWKFeNKFQRGrB8nq-JYYidJfAK1JiklXB0YsqkGOO18Dk5OiZNlF7I2Td23Gi6lOfTkaN2QZf3ewhlv7d_YXGFfBwd_XI1bDFySmE-JK_asEkB0loMtpqNoVTx2avl5AllUFChyt_82UYYbPMHhnjOipQtWAMQ_NDIH5CXHiN_EQV_y2Y5nf-Toocbjx6znQKaWyb0iY5kqhduC7NA5NHIufZNuLeswbh5FbkbjwtwgGMHU7GycDs7f71bYTbMZPEX-GJ4YUhp1FHla1lrm7N_6jiYA',
      title: '脂ぎった中年男とのドロドロ調教 星空もあ',
      video_uid: 'fb2baa36da86ee7bb9878fc2865d69bf',
      thumbnail_start_sec: 1000,
      tags: ['新作', '準新作'],
    },
    {
      token: 'eyJhbGciOiJSUzI1NiIsImtpZCI6ImUwZjdhMmQwMDAwNzExOWM2OWI4NjI0NDM5OGVlNGQ1In0.eyJzdWIiOiJhMDk0ZWZmOTFmYTA2NmFmNDI3ZmE4YTY2ODMxODY3ZiIsImtpZCI6ImUwZjdhMmQwMDAwNzExOWM2OWI4NjI0NDM5OGVlNGQ1IiwiZXhwIjoiMTczOTAzMjg1MyIsIm5iZiI6IjE3Mzg5NDI4NzMifQ.Rqiu8QIOYmBL7RGhPKlHLLNKdNZ4rHzmWPHq45ziSyO3kRfSTPw2dpx-3V4AtKDQ6iF39uoJDZD4ALruFHfrbQmg1_uVMmW2CSGwwEkkr3THoyPYZh2TnHQ9JfdxT7Dz0xM8ylDl1jQe7n9LX3qBEnA65-hkpCoK6X7gowK30FhlbRMhec2jlXwx8UFirjildOr9-m4OPo0e3sxnrrT16Ug6zpFu5HRUdXS8twQr70VWZ1MTJPuu1Ue9rlu0DFWJSEIcZJp2Owy7ZFEChmD2U_naFWLgoLPdgauhnw-tfjnWwkPCQWTf6zLW7Fh8WFzJ4Mq1tiQrW5C0-yRv1sc_qA',
      title: 'キュートな彼女 卑猥なカノジョ 令和最強ギャルと1日デート 百永さりな',
      video_uid: 'a094eff91fa066af427fa8a66831867f',
      thumbnail_start_sec: 1000,
      tags: ['新作', '準新作'],
    },
    {
      token: 'eyJhbGciOiJSUzI1NiIsImtpZCI6ImUwZjdhMmQwMDAwNzExOWM2OWI4NjI0NDM5OGVlNGQ1In0.eyJzdWIiOiJkYmYyODYyNWViNWQyOGJhYzA4MmYzZjAzMjIyOTc5NiIsImtpZCI6ImUwZjdhMmQwMDAwNzExOWM2OWI4NjI0NDM5OGVlNGQ1IiwiZXhwIjoiMTczOTAzMjg1MyIsIm5iZiI6IjE3Mzg5NDI4NzMifQ.CL2mPHrqK02Wws9Olb5PtEMI0LwWzEjSc7HIS02uKLfCDtOUJ9aHEKfTnSkkY2PAwn47T9WviL7GddaBT3D3bQoDjIyTaM_05KYRjJDBi8OdXP7WvA3jEMDc1QcNsZvGSXrGjUR4dEDDPrP4-r3PRx5aIV_9d0juEpy0MhO-Xb9QZy1CULjeR4L53heMf5WImc2dwMUkIjMlb85ik6NHkkd3lm_g4vcCgoKib_d2VQxyWWErmPdDLWUM-7-Eo_pOaOber3X52hmlu1oR-8L0gkyC20XR_im4K42UQDyzkwgLjqnfIagcwaR_JNbkHxrgdIbt3uSbW9eQEHrUJzffmg',
      title: 'ショートカット美少女',
      video_uid: 'dbf28625eb5d28bac082f3f032229796',
      thumbnail_start_sec: 1000,
      tags: ['新作', '準新作'],
    },
    {
      token: 'eyJhbGciOiJSUzI1NiIsImtpZCI6ImUwZjdhMmQwMDAwNzExOWM2OWI4NjI0NDM5OGVlNGQ1In0.eyJzdWIiOiJhN2JjN2UyMDk2MDZlYTMzNDdkNTAwNzRlZTczNmM2OSIsImtpZCI6ImUwZjdhMmQwMDAwNzExOWM2OWI4NjI0NDM5OGVlNGQ1IiwiZXhwIjoiMTczOTAzMjg1NCIsIm5iZiI6IjE3Mzg5NDI4NzQifQ.YfYqvCN3ELFkF-MWUYn-UGqRHLbg-Q0qAsZVVVUPkGaKVjvsqP985kbb1GGKZuJputvoRHjU282qx_0rBP2hnbHTKXeTr5XUzpWJK5t2graQ6ScV1RQTN76sf4ok3ZGlKHMKUap7HBzZyTPxbBtJjd1LkzkW7SFy63hXMcv03Yk_8E4p-uPUfRs5CUwbZxItBuY7tSqB7LfR5DHaQewpGveuuOhu2rscsoeg-7AhnlJmSc3a2IHhk7o-SPz9SW0YnHbbQt2PCvUVY_cCZ9xTIaz4uQImu0JymwrmHBoSYYEI1W6KdmtKLnlfJIwf8j-1ABK7pfwvWl8Bd3V0nUoSeA',
      title: '出張中に手違いで女上司とまさかの相部屋で飲み説教中 酔って無防備なノーブラ生乳が気になって仕方がない…。',
      video_uid: 'a7bc7e209606ea3347d50074ee736c69',
      thumbnail_start_sec: 1000,
      tags: ['新作', '準新作'],
    },
  ];

  return (
    <AppBar
      title={
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          height="100%" // 必要に応じて高さを調整
        >
          <img
            src="/pornomax_logo.png"
            alt="Logo"
            style={{height: '40px'}}
          />
        </Box>
      }
    >
      <Stack spacing={2} margin={2} paddingTop={2}>
        <img
          src="/porn_max_ban@3x.png"
          alt="banner"
        />
      </Stack>

      <Grid container spacing={0} marginTop={0} paddingLeft={2} paddingRight={2} gap={3} marginBottom={2}>
        {CFStreamSignedItems.map((video,) => (
          <Grid item xs={12} sm={12} key={video.token}>
            <Stack direction="row" spacing={1}>
              {video.tags.map((tag, index) => (
                <SmallGenreButton
                  key={index}
                  label={tag}
                  onClick={() => {
                    console.log(`Clicked on tag: ${tag}`);
                  }}
                />
              ))}
            </Stack>
            <Swiper
              modules={[Navigation, Pagination]}
              pagination
              navigation
            >
              <Box>
                <Typography variant="body2" color="text.primary">
                  {video.title}
                </Typography>
                <LightStreamPlayer
                  src={video.token}
                  video_uid={video.video_uid}
                  thumbnail_start_sec={video.thumbnail_start_sec}
                />
              </Box>
            </Swiper>
          </Grid>
        ))}
      </Grid>

    </AppBar>
  );
}
